import { PASSWORD_LENGTH_LIMITS } from '../constants/common';

export type PasswordRule = { regex: RegExp; message: string };

// Kept in sync with the backend's password-complexity DTOs
// (ResetPasswordDto / SetPasswordDto / CreateUserByUserDto / ChangePasswordDto).
export const PASSWORD_STRENGTH_RULES: PasswordRule[] = [
  { regex: /[a-z]/, message: 'Password must contain at least one lowercase letter' },
  { regex: /[A-Z]/, message: 'Password must contain at least one uppercase letter' },
  { regex: /\d/, message: 'Password must contain at least one number' },
  { regex: /[!@#$%^&*(),.?":{}|<>[\]\\/~`_\-+=]/, message: 'Password must contain at least one special character' },
];

export const PASSWORD_RULES_HINT = `Password must be ${PASSWORD_LENGTH_LIMITS.MIN}-${PASSWORD_LENGTH_LIMITS.MAX} characters and include at least one lowercase letter, one uppercase letter, one number, and one special character.`;

export const getPasswordStrengthError = (password: string): string | null => {
  if (password.length < PASSWORD_LENGTH_LIMITS.MIN) {
    return `Password must be at least ${PASSWORD_LENGTH_LIMITS.MIN} characters long`;
  }

  if (password.length > PASSWORD_LENGTH_LIMITS.MAX) {
    return `Password must be at most ${PASSWORD_LENGTH_LIMITS.MAX} characters long`;
  }

  const failedRule = PASSWORD_STRENGTH_RULES.find((rule) => !rule.regex.test(password));

  return failedRule?.message ?? null;
};
